import { Application } from '@hotwired/stimulus'
import CalculatorController from './controllers/calculator-controller'
import CarouselController from './controllers/carousel-controller'
import StickyNavController from './controllers/stickynav-controller'
import TabsController from './controllers/tabs-controller'
import EmailCaptureController from './controllers/emailcapture-controller'
import TooltipController from './controllers/tooltip-controller'
import TopPicksController from './controllers/top-picks-controller'
import TriageController from './controllers/triage-controller'
import ChartController from './controllers/chart-controller'
import ErrorHandlerController from './controllers/error-handler-controller'
import StickyTopNavController from './controllers/sticky-top-nav-controller'
const application = Application.start()
application.register('calculator', CalculatorController)
application.register('platinum-carousel', CarouselController)
application.register('sticky-nav', StickyNavController)
application.register('platinum-tabs', TabsController)
application.register('email-capture', EmailCaptureController)
application.register('platinum-tooltip', TooltipController)
application.register('top-picks', TopPicksController)
application.register('triage', TriageController)
application.register('chart', ChartController)
application.register('error-handler', ErrorHandlerController)
application.register('sticky-top-nav', StickyTopNavController)
